module.exports = __webpack_public_path__ + "img/shop.9eab64fe.svg";